import { useEffect, useState } from "react";
import { DataGridPro, esES, LicenseInfo } from "@mui/x-data-grid-pro";
import { XGridStyles } from "./Xgrid.styles";
import {
  generateColumns,
  validateRowSelected,
} from "../../../services/Local-services";
import { routeInfo, rowSelected } from "../../../recoilState/GlobalState";
import { useRecoilState, useRecoilValue } from "recoil";

export default function ServerPaginationGrid({
  titles,
  updateList = async () => {},
  onPageChange = () => {},
  onPageSizeChange = () => {},
  onNumberOfPagesChange = () => {},
  forceUpload = false,
  selectedActive = true
}) {
  const [isLoading, setIsLoading] = useState(true);
  const { route } = useRecoilValue(routeInfo);
  const [selected, setSelected] = useRecoilState(rowSelected);
  const [rows, setRows] = useState([]);
  const [pages, setPages] = useState({});
  const [rowCount, setRowCount] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(1);
  const [upload, setUpload] = useState(false);

  const getList = async (newPage = 0, force = false) => {
    if (!force && pages[newPage] && newPage !== numberOfPages) {
      return setRows(pages[newPage]);
    }
    setIsLoading(true);
    const { rows: newRows, rowCount: newRowCount } = await updateList(
      newPage,
      pageSize
    );

    setRows(newRows);

    const newPages = { ...pages };
    newPages[newPage] = newRows;
    setPages(newPages);

    setRowCount(newRowCount);
    setIsLoading(false);
  };

  useEffect(() => {
    if (pageSize > 0 && rows.length === 0) {
      getList();
    }
  }, [pageSize, rows]);

  useEffect(() => {
    setUpload(forceUpload);
    if (forceUpload !== upload) getList(page, true);
  }, [forceUpload]);

  const columns = generateColumns(titles, route);
  const classes = XGridStyles();
  LicenseInfo.setLicenseKey(
    "ac8c44d2650f10c5456f59e7602dc69cTz0xMTE5MzIsRT0xNzc3MDc1MTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI="
  );
  return (
    <DataGridPro
      columns={columns}
      rows={rows ?? []}
      rowCount={rowCount ?? rows.length}
      count={pageSize}
      loading={isLoading}
      onRowClick={(data, event) =>{
        if(selectedActive){
          validateRowSelected(data, event, selected.row, setSelected)
        }
      }
      }
      pagination
      page={page}
      // pageSize={pageSize}
      paginationMode="server"
      onPageChange={(newPage) => {
        setPage(newPage);
        onPageChange(newPage);
        getList(newPage);
      }}
      onStateChange={(state) => {
        const newNumberOfPages = state.pagination.pageCount + 1;
        if(pageSize === 0 || pageSize === state?.pagination?.paginationModel?.pageSize){
          onPageSizeChange(state?.pagination?.paginationModel?.pageSize)
        }
        if (newNumberOfPages !== numberOfPages) {
          setNumberOfPages(newNumberOfPages);
          onNumberOfPagesChange(newNumberOfPages);
        }
      }}
      onPageSizeChange={(newPageSize) => {
        console.log(newPageSize)
          setPageSize(newPageSize);
          onPageSizeChange(newPageSize);
      }}
      className={classes.root}
      autoPageSize
      hideFooterSelectedRowCount
      disableMultipleSelection
      rowHeight={32}
      disableColumnMenu
      localeText={{ ...esES.components.MuiDataGrid.defaultProps.localeText, noRowsLabel: "Sin datos" }}
    />
  );
}
